<div mat-dialog-content>
    <h2 class="verify-title">Enter Phone</h2>

    <h3>Type the phone number you want to use for SMS codes. Please, don't forget to use your country code.</h3>

    <form [formGroup]="formGroup">
        <mat-form-field class="mfa-phone mb-8">
            <input matInput type="tel" formControlName="phone" ngcAutofocus>
            <mat-error *ngIf="formGroup.controls?.phone?.errors?.phoneNumberIsInvalid" class="mt-4">Phone number
                is invalid
            </mat-error>
            <mat-error *ngIf="formGroup.controls?.phone?.errors?.samePhoneNumberError" class="mt-4">Please enter
                a new phone number.
            </mat-error>
        </mat-form-field>
    </form>
</div>

<mat-dialog-actions fxLayout="row" fxLayoutAlign="end center">
    <div class="action-buttons-block">
        <button mat-button
                type="button"
                (click)="doCancel()"
                class="mr-8"
                tabindex="12"
        >
            Cancel
        </button>
        <button mat-raised-button
                color="primary"
                (click)="onSendCode()"
                [disabled]="formGroup?.invalid || isSpinnerActive"
        >
            Continue
        </button>
    </div>
</mat-dialog-actions>
